"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepLinkingEvents = exports.appointmentPurposeModes = exports.userEvents = exports.pageEvents = void 0;
const USER_ACTION = 'user_action';
const USER_ACTION_PAGE_VIEW = `${USER_ACTION}.page_view`;
exports.pageEvents = {
    DBOOK_LANDING: `${USER_ACTION_PAGE_VIEW}.directbook_landing`,
    APPOINTMENT_REASON: `${USER_ACTION_PAGE_VIEW}.appointment_reason`,
    PROVIDER_SCHEDULE: `${USER_ACTION_PAGE_VIEW}.provider_schedule`,
    PATIENT_REGISTRATION: `${USER_ACTION_PAGE_VIEW}.patient_registration`,
    CONFIRM_APPOINTMENT: `${USER_ACTION_PAGE_VIEW}.confirm_appointment`,
    BOOKED_APPOINTMENT: `${USER_ACTION_PAGE_VIEW}.booked_appointment`,
    EPIC_OSW: `${USER_ACTION_PAGE_VIEW}.epic_osw`
};
exports.userEvents = {
    SET_PATIENT_REL: `${USER_ACTION}.existing_patient_view.select_patient_type`,
    SET_PURPOSE: `${USER_ACTION}.existing_patient_view.select_purpose_type`,
    APPT_INFO_NEXT: `${USER_ACTION}.existing_patient_view.next`,
    PRINT: `${USER_ACTION}.appt_booked_view.click_print_confirmation`,
    ADD_TO_CAL: `${USER_ACTION}.appt_booked_view.add_to_calendar`,
    BOOK_APPT: `${USER_ACTION}.confirm_appointment_view.click_book_appointment`,
    APPT_CHANGE_LOC: `${USER_ACTION}.provider_schedule_view.change_location_filter`,
    APPT_CHANGE_DAY: `${USER_ACTION}.provider_schedule_view.change_day_filter`,
    APPT_CHANGE_TIME: `${USER_ACTION}.provider_schedule_view.change_time_filter`,
    APPT_JUMP_TO_DATE: `${USER_ACTION}.jump_to_date`,
    APPT_JUMP_TO_DATE_NO_RESULTS: `${USER_ACTION}.jump_to_date.no_results`,
    APPT_LOAD_MORE: `${USER_ACTION}.load_more_appointments`,
    APPT_NO_RESULTS: `${USER_ACTION}.error.provider_schedule.no_results`,
    GX_QUESTION_ANSWER: `${USER_ACTION}.gx_question_answer`,
    PATIENT_REG_EHR_LOGIN: `${USER_ACTION}.patient_registration.click_ehr_login`,
    BOOKING_DISABLED: `${USER_ACTION}.error.provider.direct_book_disabled`,
    GENERIC_LOAD_ERROR: `${USER_ACTION}.error.provider.load_data_failed`,
    PATIENT_REG_FORM_FAIL: `${USER_ACTION}.error.no_reg_form_config`,
    APPT_BOOKED_NEW_RELATIONSHIP: `${USER_ACTION}.response_new_patient`,
    APPT_BOOKED_ESTABLISHED_RELATIONSHIP: `${USER_ACTION}.response_established_patient`,
    BACK_SEARCH_PAGE_BUTTON_CLICK_MOBILE: `${USER_ACTION}.back_search_page_button_click_mobile`,
    BACK_SEARCH_PAGE_BUTTON_CLICK_DESKTOP: `${USER_ACTION}.back_search_page_button_click_desktop`,
    GO_BACK_TO_PREVIOUS_STEP: `${USER_ACTION}.go_back_to_previous_step`
};
exports.appointmentPurposeModes = {
    NO_PURPOSES_ERR: 'no_purposes_error',
    PURPOSES_DROPDOWN: 'purposes_dropdown',
    NO_AVAIL_PATIENT_REL_ERR: 'no_availability_for_patient_rel_error',
    NO_AVAIL_PURPOSES_ERR: 'no_availability_for_purpose_error'
};
exports.deepLinkingEvents = {
    TIME_SLOT_UNAVAILABLE_ERR: 'deep_linking_time_slot_unavailable_error'
};
//# sourceMappingURL=Tracking.js.map